import React from "react";
import { Input } from "antd";
import { TextareaEventProps } from "../../../../../../Service";

interface Props extends TextareaEventProps {}

const { TextArea } = Input;
const Index = ({ onChange, value, onSave, ...restProps }: Props) => {
    return (
        <TextArea
            {...restProps}
            rows={10}
            onChange={event => {
                onChange?.(event.target.value);
            }}
            onBlur={event => {
                onSave?.(event.target.value);
            }}
            placeholder="请输入"
            value={value}
        />
    );
};

export default Index;
